var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'mb-2',
    'px-3',
    'py-2',
    'text-center',
    'clickable',
    'job-question',
    'position-relative',
    {
      selected: _vm.isSelected,
    } ],on:{"click":function($event){_vm.$emit('select-question', _vm.jobQuestion.id)}}},[_c('b-row',[_c('b-col',[_c('span',{staticClass:"job-question-label"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }